import {
  useFeatureFlag,
  VISUAL_FILTERS_TEST
} from './constants/signalmizelyConstants';

// eslint-disable-next-line import/prefer-default-export
export function visualFiltersTest() {
  return useFeatureFlag(VISUAL_FILTERS_TEST);
}
